export enum ClickstreamInteractionEventType {
  EntrySurvey,
  Video,
  AskQuestion,
  ReAskQuestion,
  AnswerQuestion,
  Inactivity,
}

export enum ClickstreamEventTypeName {
  SessionStart = 'SessionStart',
  ActivityBegin = 'ActivityBegin',
  AmiraActivityContinue = 'AmiraActivityContinue',
  ActivityComplete = 'ActivityComplete',
  AmiraActivityComplete = 'AmiraActivityComplete',
  AskQuestion = 'AskQuestion',
  AnswerCorrect = 'AnswerCorrect',
  AnswerIncorrect = 'AnswerIncorrect',
  ActivityInterrupt = 'ActivityInterrupt',
  Inactivity = 'Inactivity',
  Event = 'Event',
  SupervisorContext = 'SupervisorContext',
}

export enum ClickstreamEventTypeIndex {
  Error,
  MouseMove,
  KeyUp,
  KeyDown,
  KeyPress,
  BrowseEnter,
  BrowseLeave,
  BrowseOver,
  Event,
  TimeLineBegin,
  TimeLineEnd,
  SceneRun,
  SceneFinished,
  ActivityEnter,
  ActivityExit,
  ActivityBegin,
  AmiraActivityContinue,
  ActivityComplete,
  AmiraActivityComplete,
  ActivityValue,
  ActivityParameter,
  AnswerCorrect,
  AnswerIncorrect,
  MasteryAchieved,
  DebugDataSet,
  ActivityInterrupt,
  AssessmentComplete,
  Inactivity,
  SkillAssessment,
  AskQuestion,
  SupervisorContext,
  SessionStart,
  RuntimePaused,
  RuntimeResumed,
  AssessmentResult,
  ClickStats,
  TransBegin,
  TransRollback,
  TransCommit,
  TransContinue,
  UserActivityEvent,
  AnalyticsEvent,
  ORFActivityEvent,
  Unknown = 0xff,
}
